import { render, staticRenderFns } from "./PurchaseInvoicing.vue?vue&type=template&id=2fe5415f&scoped=true&"
import script from "./PurchaseInvoicing.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicing.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoicing.vue?vue&type=style&index=0&id=2fe5415f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5415f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe5415f')) {
      api.createRecord('2fe5415f', component.options)
    } else {
      api.reload('2fe5415f', component.options)
    }
    module.hot.accept("./PurchaseInvoicing.vue?vue&type=template&id=2fe5415f&scoped=true&", function () {
      api.rerender('2fe5415f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PurchaseInvoicing.vue"
export default component.exports